import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as addUserBlackListFromCreateReduceObject } from './addUserBlackListForm/reduce';
import addUserBlackListFormSaga from './addUserBlackListForm/sagas/addUserBlackListFormSaga';

import { createReduceObject as removeUserBlackListFormCreateReduceObject } from './removeUserBlackListForm/reduce';
import removeUserBlackListFormSaga from './removeUserBlackListForm/sagas/removeUserBlackListFormSaga';

export default [
  // Forms
  ...createCombineMapItem(
    'addUserBlackListForm',
    addUserBlackListFromCreateReduceObject,
    [addUserBlackListFormSaga]
  ),
  // дублируем для каждого из списков чтобы отлавливать отдельно для обновления черных списков в интерфесе
  // (обновлялись сраз 2 списка)
  ...createCombineMapItem(
    'removeUserBlackListByCustomersForm',
    removeUserBlackListFormCreateReduceObject,
    [removeUserBlackListFormSaga]
  ),
  ...createCombineMapItem(
    'removeUserBlackListByExecutorsForm',
    removeUserBlackListFormCreateReduceObject,
    [removeUserBlackListFormSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/reducers/static/forms/reducersMap.js